import { formatLanguage, SegmentedControl } from '@platform/design-system';
import { isLocale, SUPPORTED_LOCALES, useTranslation, type Locale } from '@platform/i18n';
import { useRouter } from '@tanstack/react-router';
import { showLocaleInUrl } from '../app/locale-path.ts';
import { useShell } from './shell.store.ts';

const LOCALE_MARKS: Readonly<Record<Locale, string>> = { fr: 'FR', ar: 'ع', en: 'EN' };

export const LocaleSwitch = () => {
  const { t, i18n } = useTranslation();
  const setLocale = useShell((state) => state.setLocale);
  const router = useRouter();
  const current = isLocale(i18n.language) ? i18n.language : SUPPORTED_LOCALES[0];
  return (
    <SegmentedControl
      label={t('shell.language')}
      value={current}
      segments={SUPPORTED_LOCALES.map((locale) => ({
        value: locale,
        label: LOCALE_MARKS[locale],
        name: formatLanguage(locale, i18n.language),
        lang: locale,
      }))}
      onChange={(locale) => {
        void i18n.changeLanguage(locale);
        setLocale(locale);
        showLocaleInUrl(router.history, locale);
      }}
    />
  );
};
